import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
//Components
import Layout from '../../common/Layout';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { Box, Button, Paper } from '@material-ui/core';
import { useSyles } from './styles.style';
import { getSessionLoans } from '../../../redux/loans/thunks';
import WrapperLoan from '../../common/WrapperLoan';
import { Close, VpnKey } from '@material-ui/icons';
import SearchInvisible from '../../common/SearchInvisible/SearchInvisible';
import ButtonBarcode from '../../common/ButtonBarcode';
import { setCurrent } from '../../../redux/renovation/thunk';
import useScan from '../../../hooks/useScan';
import Swal from 'sweetalert2';
import { RenovationKeyField } from '../../../domain/constants/RenovationField';
import { getAllUsers } from '../../../redux/users/thunks';
import { RootState } from '../../../domain/models/RootState';
import { Step, Stepper } from '../../common/Steper';
import {
  initialError,
  initialSteps,
  initialValidations,
  initialValuesLoan,
  StepsP2P,
} from './model';
import { createLoanP2P } from '../../../redux/loans_p2p/thunks';

export const NewLoansP2P = (_: any) => {
  const dispatch = useDispatch<any>();
  const classes: any = useSyles();
  const navigate = useNavigate();
  const [showResume, setShowResume] = useState(false);
  const [keysLoan, setKeysLoan] = useState<any>([]);

  const [error, setError] = useState(initialError);
  const [sending, setSending] = useState(false);
  const [currentStep, setCurrentStep] = useState(StepsP2P.VerifyLoans);
  const [listSteps, setListSteps] = useState(initialSteps);
  const [validations, setValidations] = useState(initialValidations);
  const [valuesLoan, setValuesLoan] = useState(initialValuesLoan);
  const [userSelected, setUserSelected] = useState<any>({});

  // obtener el state
  const { keys } = useSelector((state: RootState) => state.loans.sessionLoans);
  const { loading: loadingLoans } = useSelector(
    (state: RootState) => state.loans
  );
  const userAuth = useSelector((state: RootState) => state.auth);
  const renovation = useSelector((state: any) => state.renovation);
  const { setDestination } = useScan();

  /* buscar usuario */
  const submitFilterUser = (value: any) => {
    if (value) {
      const isEmail = value.includes('@');
      const filter = isEmail ? `&email=${value}` : `&id=${value}`;
      const isAuthUser =
        userAuth.id.toString() === value.toString() ||
        userAuth.user.toString() === value.toString();
      if (isAuthUser) {
        setValuesLoan({ ...valuesLoan, users_id: '' });
        setValidations({ ...validations, user: false });
        return setError({
          ...error,
          user: 'No puedes transferir llaves a ti mismo.',
        });
      }
      dispatch(getAllUsers({ filter, pagination: {} }))
        .unwrap()
        .then((res: any) => {
          const user = res.users?.find((u: any) =>
            isEmail ? u.email === value : Number(u.id) === Number(value)
          );
          if (user) {
            setUserSelected(user);
            setValuesLoan({ ...valuesLoan, users_id: user.id });
            setCurrentStep(StepsP2P.SelectKeys);
            setValidations({ ...validations, user: true });
            setError({ ...error, user: '' });
          } else {
            setValuesLoan({ ...valuesLoan, users_id: '' });
            setValidations({ ...validations, user: false });
            setError({
              ...error,
              user: 'El usuario seleccionado no se encuentra disponible.',
            });
          }
        });
    } else {
      setValuesLoan({ ...valuesLoan, users_id: '' });
      setValidations({ ...validations, user: false });
    }
  };

  /* agregar llaves*/
  const submitkeys = (value: any) => {
    const index = keysLoan?.findIndex((item: any) => item.barcode === value);
    if (index !== -1) {
      const _keysLoan = [...keysLoan];
      _keysLoan[index].active = !_keysLoan[index].active;
      const activeKeys = _keysLoan.filter((k) => k.active).length;
      setValidations({ ...validations, keys: activeKeys > 0 });
      setKeysLoan(_keysLoan);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'La llave escaneada, no corresponde con ninguna en prestamo',
        text: 'Por favor, intenta de nuevo',
      });
    }
  };

  // cancelar
  const handleCancel = () => {
    setValidations(initialValidations);
    setValuesLoan(initialValuesLoan);
    setCurrentStep(StepsP2P.SelectUser);
    setKeysLoan([]);
    setShowResume(false);
    setError(initialError);
  };

  // continuar
  const handleContinue = () => {
    const activeKeys = keysLoan.filter((k: any) => k.active);
    const selectedKeys = activeKeys.map((key: any) => key.keys_id);
    setValuesLoan({ ...valuesLoan, keys: selectedKeys });
    setKeysLoan(activeKeys);
    setShowResume(true);
    if (validations.user && validations.keys) {
      setValidations({ ...validations, complete: true });
      setCurrentStep(StepsP2P.ConfirmSend);
    }
  };

  const handleSendLoan = () => {
    const { users_id, keys } = valuesLoan;
    if (users_id && keys.length > 0) {
      setSending(true);
      if (sending) {
        return;
      }
      dispatch(createLoanP2P({ target_user_id: Number(users_id), keys }))
        .unwrap()
        .then(() => {
          setTimeout(function () {
            navigate(`/p2p/loans`, { replace: true });
          }, 1500);
        });
    }
  };

  const fetchMyLoans = useCallback(() => {
    dispatch(getSessionLoans())
      .unwrap()
      .then((res: any) => {
        setSending(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //Código de barras
  useEffect(() => {
    const executeProcess = async () => {
      if (renovation?.actionInProcess) {
        switch (renovation.process.prefix.toLowerCase()) {
          case 'usr':
            submitFilterUser(renovation.process.id);
            break;
          case RenovationKeyField.prefix:
            submitkeys(renovation.process.barcode);
            break;
          case 'con':
            handleContinue();
            break;
          case 'can':
            handleCancel();
            break;
          case 'fin':
            handleSendLoan();
            break;
        }
        dispatch(
          setCurrent({
            currentView: renovation.currentView,
            url: renovation.url,
            actionInProcess: false,
            process: {},
            title: renovation.title,
          })
        );
      }
    };
    executeProcess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renovation?.actionInProcess]);

  useEffect(() => {
    const keysAvailable = keys
      ?.filter((item: any) => item?.loan?.days_past_due >= 0)
      .map((item: any) => {
        return { ...item, active: false };
      });
    if (keysAvailable?.length > 0) {
      setCurrentStep(StepsP2P.SelectUser);
      setListSteps(
        listSteps.map((step: Step) => {
          if (step.label === 'Prestamos') {
            return { ...step, error: false };
          }
          return step;
        })
      );
    } else {
      setListSteps(
        listSteps.map((step: Step) => {
          if (step.label === 'Prestamos') {
            return { ...step, error: true };
          }
          return step;
        })
      );
    }
    setKeysLoan(keysAvailable);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keys]);

  useEffect(() => {
    setDestination('act-a-p2p', false);
    fetchMyLoans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Fin de los filtros
  return (
    <Layout>
      <WrapperLoan>
        <Stepper steps={listSteps} activeStep={currentStep} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-evenly',
            gridGap: '16px',
            minHeight: '80px',
          }}
          className={`${showResume ? classes.resume : ''}`}
        >
          {validations.user && (
            <Box>
              <Box className={classes.info}>
                <p>
                  <b>Usuario: </b> {userSelected?.name}
                </p>
                <p>{userSelected?.email}</p>
                {!showResume && (
                  <div className={classes.close} onClick={() => handleCancel()}>
                    <Close />
                  </div>
                )}
              </Box>
            </Box>
          )}
          {error.user && (
            <Box className={classes.info}>
              <div className={classes.close} onClick={() => handleCancel()}>
                <Close />
              </div>
              {error.user}
            </Box>
          )}
          {/* listado de llaves */}
          {validations.user && keysLoan?.length > 0 && (
            <Box className={classes.boxButtons}>
              {keysLoan?.map((key: any) => (
                <Box key={key.keys_id}>
                  <Button
                    className={`${classes.buttonkey} ${
                      key.active ? classes.buttonKeyActive : ''
                    }`}
                    variant={key.active ? 'outlined' : 'text'}
                    startIcon={<VpnKey />}
                    onClick={
                      showResume ? undefined : () => submitkeys(key.barcode)
                    }
                  >
                    <span className='barcode'>{key.barcode}</span>
                    <span className='type'>{key.type_keys_str}</span>
                    <span className='description'>{key.description}</span>
                  </Button>
                </Box>
              ))}
            </Box>
          )}
          {currentStep === StepsP2P.VerifyLoans && !loadingLoans && (
            <Box flex flexDirection='column' padding={3}>
              <Paper
                elevation={2}
                style={{
                  fontSize: '20px',
                  padding: 3,
                  backgroundColor: '#FFDEDE',
                }}
              >
                <b>No tienes llaves disponibles para transferir.</b>
              </Paper>
              <p>Algunos consejos:</p>
              <ul>
                <li>
                  Solo puedes transferir llaves que <b>tú tengas prestadas</b>.
                </li>
                <li>
                  Los prestamos de las llaves que quieres transferir{' '}
                  <b>no deben estar vencidos.</b>
                </li>
                <li>
                  Las llaves <b>no deben estar en alguna transacción activa</b>.
                  Intenta cancelar las transacciones de las llaves que ya no
                  quieras transferir.
                </li>
              </ul>
            </Box>
          )}
          {currentStep === StepsP2P.VerifyLoans && loadingLoans && (
            <p>Verificando prestamos activos...</p>
          )}
          {currentStep === StepsP2P.ConfirmSend && sending && (
            <p>Creando registro de transferencia de llaves...</p>
          )}
        </Box>
        <Box sx={{ display: 'block', position: 'relative', height: '50px' }}>
          {/* seleccionar llaves */}
          {currentStep === StepsP2P.SelectKeys && !showResume && (
            <SearchInvisible
              onHandleChange={submitkeys}
              placeholder='Escanea o selecciona el código de las llaves'
            />
          )}

          {/* buscador información usuario */}
          {currentStep === StepsP2P.SelectUser && !validations.user && (
            <SearchInvisible
              onHandleChange={submitFilterUser}
              placeholder='Correo o ID de usuario'
            />
          )}
          {currentStep === StepsP2P.ConfirmSend && validations.complete && (
            <Box className={classes.verification}>
              Verifique los datos para finalizar
            </Box>
          )}
        </Box>

        {validations.keys && validations.user && !showResume && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-evenly',
              gridGap: '16px',
            }}
          >
            <ButtonBarcode
              id=''
              src='/barcodes/cancelar.png'
              onClick={handleCancel}
            />
            <ButtonBarcode
              id=''
              src='/barcodes/continuar.png'
              onClick={handleContinue}
            />
          </Box>
        )}
        {validations.keys && showResume && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-evenly',
              gridGap: '16px',
            }}
          >
            <ButtonBarcode
              id=''
              src='/barcodes/cancelar.png'
              onClick={handleCancel}
            />
            <ButtonBarcode
              id=''
              src='/barcodes/finalizar.png'
              onClick={handleSendLoan}
            />
          </Box>
        )}
      </WrapperLoan>
    </Layout>
  );
};
